import { useEffect, useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import styles from "./Slider.module.css";
import LoadImages from "../../components/LoadImages";

function Slider({ data }) {
  const images = data.images;
  const startImage = images.length === 0 
    ? "../../images/HF_rb_gudstjenste_Velkommen.jpg" 
    : images[0];

  const API_URL = process.env.NODE_ENV === "development"
    ? "http://localhost:3000/"
    : "https://api.hillerodfrimenighed.dk/";

  const [events, setEvents] = useState([]);
  const [imageUrls, setImageUrls] = useState([]);

 

  useEffect(() => {
    async function loadSliderData() {
      try {
        const response = await fetch(`${API_URL}calendar/events/withImages`);
        const events = await response.json();
        setImageUrls(events.map(event => `${API_URL}${event.imageUrl}`))

        setEvents(events);
      } catch (err) {
        console.error("Error loading events or images:", err);
      } 
    }

    loadSliderData();
  }, [API_URL, images]);

  return (
    <div>
      <LoadImages images={imageUrls}/>
      <Carousel className={styles.Carousel}>
        
        <Carousel.Item className={styles.CarouselItem}>
          <div
            className={styles.CarouselImg}
            style={{ backgroundImage: `url(${startImage})` }}
          />
        </Carousel.Item>

        {events.length > 0 &&
          events.map((event) => (
            <Carousel.Item className={styles.CarouselItem} key={`event-${event.id}`}>
              <div
                className={styles.CarouselImg}
                style={{ backgroundImage: `url(${API_URL}${event.imageUrl})` }}
              />
            </Carousel.Item>
          ))}

        {images.length > 1 &&
          images.slice(1).map((image, index) => (
            <Carousel.Item className={styles.CarouselItem} key={`image-${index}`}>
              <div
                className={styles.CarouselImg}
                style={{ backgroundImage: `url(${image})` }}
              />
            </Carousel.Item>
          ))}
      </Carousel>

    </div>
      );
}

export default Slider;
